import React, { useState, useEffect } from "react";
import Input from "../Input";
import Button from "../Button";
import { fetchJson, post } from "../../lib/Fetching";

const sampleRegex = /^S(\w+)/;
const preprintedRegex = /(^PP.*)/;

export default function TrayScanner({ onScanTray, onScanSample, placeholder }) {
  const [barcode, setBarcode] = useState("");
  const [item, setItem] = useState(null);

  const scan = () => {
    if (!barcode) return;
    const match = sampleRegex.exec(barcode) || preprintedRegex.exec(barcode);
    if (match) {
      onScanSample(match[1]);
      setBarcode("");
      return;
    }
    fetchJson("/trays/trays/find", { item_id: barcode }).then((json) => {
      if (json.errors) {
        alert(json.errors);
        return;
      }
      if (json.tray) {
        onScanTray(json.tray);
        setBarcode("");
        return;
      }
      if (json.item) {
        setItem(json.item);
      }
    });
  };

  const createTray = () => {
    if (!item) return;
    post("/trays/trays", { item_id: item.id }).then((json) => {
      if (json.errors) {
        alert(json.errors);
        return;
      }
      onScanTray(json.tray);
      setItem(null);
      setBarcode("");
    });
  };

  return (
    <div>
      <Input
        value={barcode}
        onChange={(e) => setBarcode(e.target.value)}
        onPressEnter={scan}
        className="form-control input-lg"
        placeholder={placeholder}
        focus
      />
      {item && (
        <div style={{ marginTop: 10 }}>
          <Button
            primary
            small
            title="Make this item a Tray"
            onClick={createTray}
            style={{ marginRight: 20 }}
          />
          Item: {item.name} is currently not marked as a tray.
        </div>
      )}
    </div>
  );
}
